import getClientConfig from './getClientConfig';
import Chance from "chance";
import { getAccessToken } from './tokenStorage';

export const addDefaultOptions = options => {
  const chance = new Chance();
  const { enableAvalaraIdentityJwt } = getClientConfig();

  const defaultOptions = {
    credentials: 'include',
    headers: {
      'x-api-version': 0,
      'X-Correlation-ID': chance.guid()
    },
  };

  if( enableAvalaraIdentityJwt && !defaultOptions.headers.hasOwnProperty('Authorization')){
    defaultOptions.headers['Authorization'] = `Bearer ${getAccessToken()}`;
  }

  if (localStorage.hasOwnProperty('mvrCustomerId') && localStorage.mvrCustomerId != null) {
    defaultOptions.headers['x-avalara-svr-customerid'] = localStorage.mvrCustomerId;
  }

  // Incoming options will overwrite defaultOptions
  return { 
    ...defaultOptions, 
    ...options,
    headers: {
      ...defaultOptions.headers, 
      ...options.headers,
    } 
  };
};

const fetchWithContentTypeHeaders = async (url, modifiedOptions) => {
  if (modifiedOptions.contentType) {
    const headers = modifiedOptions.headers || new Headers();
    const { contentType } = modifiedOptions;
    if (headers.constructor == Headers) {
      // Headers type does not support [] syntax so handle separately from plain objects
      if (!headers.has('content-type') && contentType) {
        headers.set('content-type', contentType);
      }
    } else {
      if (!headers['content-type']) {
        headers['content-type'] = contentType;
      }
    }
    modifiedOptions.headers = headers;
  }

  const response = await fetch(url, modifiedOptions);

  return response;
}

export const fetchWithoutDefaultAuthHeaders = async (url, options = {}) => {
  const modifiedOptions = addDefaultOptions(options);

  return await fetchWithContentTypeHeaders(url, modifiedOptions);
};

export const fetchWithOnlyJwtAuthHeader = async (url, options = {}) => {
  const { enableAvalaraIdentityJwt } = getClientConfig();
  options.headers = options.headers || {};
  if (enableAvalaraIdentityJwt && !options.headers.Authorization) {
    options.headers['Authorization'] = `Bearer ${getAccessToken()}`;
  }

  const response = await fetch(url, options);

  return response;
};

const defaultFetch = async (url, options = {}) => {
  const { enableAvalaraIdentity, enableAvalaraIdentityJwt } = getClientConfig();
  
  const modifiedOptions = addDefaultOptions(options);
  
  // If Avalara Identity is disabled, add legacy Auth header
  if (!(enableAvalaraIdentity || enableAvalaraIdentityJwt)
    && modifiedOptions.headers
    && !modifiedOptions.headers.hasOwnProperty('Authorization')) {
    modifiedOptions.headers.Authorization = sessionStorage.token;
  }

  return await fetchWithContentTypeHeaders(url, modifiedOptions);
};

export default defaultFetch;
